// Import Routes
import * as ROUTES from "../routes";
import Login from '@/modules/auth/views/login'
import FORGOTPASSWORD from '@/modules/auth/views/forgot-password'
import RESETPASSWORD from '@/modules/auth/views/reset-password'

const routes = [
    {
        path: "/",
        redirect: ROUTES.LOGIN,
    },
    {
        path: ROUTES.LOGIN,
        name: "login",
        component: Login,
        meta: {
            title: "Login",
            layout: "public",
        },
    },
    {
        path: ROUTES.FORGOTPASSWORD,
        name: "FORGOTPASSWORD",
        component: FORGOTPASSWORD,
        meta: {
            title: "Recover Password",
            layout: "public",
        }
    },
    {
        path: ROUTES.RESETPASSWORD,
        name: "RESETPASSWORD",
        component: RESETPASSWORD,
        meta: {
            title: "Reset Password",
            layout: "public",
        }
    },
]

export default routes;